if (!customElements.get('quantity-dropdown')) {
  customElements.define(
    'quantity-dropdown',
    class QuantityDropdown extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector('.quantity-dropdown__toggle');
        this.list = this.querySelector('.quantity-dropdown__list');
        this.input = this.querySelector('.quantity__input');
        this.valueDisplay = this.querySelector('.quantity-dropdown__value');
        this.changeEvent = new Event('change', { bubbles: true });

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        this.toggle.addEventListener('click', this.onToggleClick.bind(this));
        this.querySelectorAll('.quantity-dropdown__option').forEach((option) => {
          option.addEventListener('click', this.onOptionClick.bind(this));
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      get isOpen() {
        return !this.list.hidden;
      }

      open() {
        if (this.toggle.disabled || this.isOpen) return;
        this.list.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      close() {
        if (!this.isOpen) return;
        this.list.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      onToggleClick(event) {
        event.preventDefault();
        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.toggle.focus();
        }
      }

      onOptionClick(event) {
        if (this.input.disabled) return;

        const option = event.currentTarget;
        const value = option.dataset.value;

        if (this.input.value !== value) {
          this.input.value = value;
          this.input.dispatchEvent(this.changeEvent);
        }

        if (this.valueDisplay) this.valueDisplay.textContent = value;

        this.querySelectorAll('.quantity-dropdown__option').forEach((otherOption) => {
          const isSelected = otherOption === option;
          otherOption.classList.toggle('quantity-dropdown__option--selected', isSelected);
          otherOption.setAttribute('aria-selected', isSelected);
        });

        this.close();
        this.toggle.focus();
      }
    }
  );
}
